<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="title">Historical Trades</span>
      </v-card-title>
      <v-tabs v-model="tabActive" show-arrows>
        <v-tab ripple >
          Trade Executions
        </v-tab>
        <v-tab-item lazy>
          <TradeExecutions></TradeExecutions>
        </v-tab-item>
        <v-tab ripple >
          Import Upbit
        </v-tab>
        <v-tab-item lazy>
          <ImportUpbit></ImportUpbit>
        </v-tab-item>
        <v-tab ripple >
          Import Trades File
        </v-tab>
        <v-tab-item lazy>
          <ImportTradesFile></ImportTradesFile>
        </v-tab-item>
        <v-tab ripple >
          Report History
        </v-tab>
        <v-tab-item lazy>
          <ReportHistoricals></ReportHistoricals>
        </v-tab-item>
        <v-tab ripple >
          Ripple Bucket
        </v-tab>
        <v-tab-item lazy>
          <RippleBucket></RippleBucket>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import TradeExecutions from './TradeExecutions'
import ImportUpbit from './ImportUpbit'
import ImportTradesFile from './ImportTradesFile'
import ReportHistoricals from './ReportHistoricals';
import RippleBucket from './RippleBucket'
export default {
  components: {
    TradeExecutions,
    ImportUpbit,
    ImportTradesFile,
    ReportHistoricals,
    RippleBucket
  },
  data() {
    return {
      tabActive: 0
    }
  }
}
</script>